// i18n simple pour la landing Petwell
// Pour ajouter une langue :
// 1) Ajouter une entrée dans `translations` (ex. `en`).
// 2) Ajouter un bouton avec `data-lang="en"` dans le sélecteur de langue.
// 3) Reprendre les mêmes clés que pour `fr` / `it`.
const translations = {
    fr: {
        // Meta
        'meta.title': "Petwell \u2013 La solution digitale des pros du bien\u2011\xeatre animal",
        'meta.description': "Petwell : agenda en ligne, r\xe9servations, rappels automatiques, statistiques, paiements s\xe9curis\xe9s et vitrine digitale pour les pros du bien-\xeatre animal.",
        // Hero
        'hero.title': "La solution digitale des pros du bien\u2011\xeatre animal",
        'hero.cta': "Demandez une d\xe9mo",
        // Intro
        'intro.title': 'Une plateforme simple et efficace pour tout centraliser',
        'intro.text': "Les professionnels du bien\u2011\xeatre animal manquent de visibilit\xe9, perdent du temps avec l'administratif et peinent \xe0 g\xe9rer les paiements. Petwell simplifie et centralise tout.",
        // Features
        'features.title': "Fonctionnalit\xe9s",
        'features.agenda': 'Agenda en ligne',
        'features.vitrine': 'Vitrine digitale',
        'features.secure_payment': "Paiement s\xe9curis\xe9",
        'features.stats': 'Statistiques et rapports',
        'features.booking': "R\xe9servations en ligne",
        'features.reminders': 'Rappels automatiques',
        // Prepay
        'prepay.title': "Pr\xe9paiement pour limiter les no-show",
        'prepay.text': "Petwell int\xe8gre un syst\xe8me de pr\xe9paiement et de paiement fractionn\xe9 pour s\xe9curiser les rendez-vous : moins d\u2019annulations de derni\xe8re minute et plus de s\xe9r\xe9nit\xe9 pour les professionnels.",
        // Mobile
        'mobile.title': 'Un outil mobile pour les pros en mouvement',
        'mobile.text': "Avec Petwell, les professionnels g\xe8rent leur agenda, leurs r\xe9servations et leur vitrine digitale directement depuis leur smartphone. Une solution simple et flexible, id\xe9ale en d\xe9placement.",
        // Reviews
        'reviews.title': "Ce qu'en pense nos clients",
        'reviews.card1.text': "PetWell m\u2019a permis de gagner 30% de temps sur ma gestion.",
        'reviews.card1.role': "\xc9ducatrice",
        'reviews.card2.text': "Enfin une vitrine en ligne adapt\xe9e \xe0 mon m\xe9tier.",
        'reviews.card2.role': 'Comportementaliste',
        'reviews.card3.text': "Gr\xe2ce aux acomptes en ligne avec PetWell, j\u2019ai r\xe9duit mes rendez-vous manqu\xe9s de 50%.",
        'reviews.card3.role': 'Toiletteuse',
        // Contact
        'contact.title': 'Contactez-nous',
        'contact.phone_label': "T\xe9l\xe9phone",
        'contact.email_label': 'Email',
        // Footer
        'footer.copyright': "\xa9 2025 Petwell. Tous droits r\xe9serv\xe9s.",
        // Alts
        'alt.hero_image': 'Chat et chien',
        'alt.cat_on_sofa': "Chat sur un ordinateur portable",
        'alt.dog_head': "Chiot couch\xe9",
        'alt.cat_and_mouse': "Chat derri\xe8re une souris d\u2019ordinateur",
        'alt.cat_headphone': "Chat avec m\xe9gaphone et lunettes"
    },
    it: {
        // Meta
        'meta.title': "Petwell \u2013 La soluzione digitale per i professionisti del benessere animale",
        'meta.description': 'Petwell: agenda online, prenotazioni, promemoria automatici, statistiche, pagamenti sicuri e vetrina digitale per i professionisti del benessere animale.',
        // Hero
        'hero.title': 'La soluzione digitale per i professionisti del benessere animale',
        'hero.cta': 'Richiedi una demo',
        // Intro
        'intro.title': 'Una piattaforma semplice ed efficace per centralizzare tutto',
        'intro.text': "I professionisti del benessere animale mancano di visibilit\xe0, perdono tempo con l\u2019amministrativo e faticano a gestire i pagamenti. Petwell semplifica e centralizza tutto.",
        // Features
        'features.title': "Funzionalit\xe0",
        'features.agenda': 'Agenda online',
        'features.vitrine': 'Vetrina digitale',
        'features.secure_payment': 'Pagamento sicuro',
        'features.stats': 'Statistiche e report',
        'features.booking': 'Prenotazioni online',
        'features.reminders': 'Promemoria automatici',
        // Prepay
        'prepay.title': 'Prepagamento per ridurre i no-show',
        'prepay.text': "Petwell integra un sistema di prepagamento e di pagamento a rate per rendere gli appuntamenti pi\xf9 sicuri: meno cancellazioni all\u2019ultimo minuto e pi\xf9 serenit\xe0 per i professionisti.",
        // Mobile
        'mobile.title': 'Uno strumento mobile per i professionisti in movimento',
        'mobile.text': 'Con Petwell i professionisti gestiscono agenda, prenotazioni e vetrina digitale direttamente dallo smartphone. Una soluzione semplice e flessibile, ideale in spostamento.',
        // Reviews
        'reviews.title': 'Cosa pensano i nostri clienti',
        'reviews.card1.text': 'PetWell mi ha fatto risparmiare il 30% del tempo sulla gestione.',
        'reviews.card1.role': 'Educatrice',
        'reviews.card2.text': 'Finalmente una vetrina online adatta al mio mestiere.',
        'reviews.card2.role': 'Comportamentista',
        'reviews.card3.text': 'Grazie agli acconti online con PetWell ho dimezzato gli appuntamenti mancati.',
        'reviews.card3.role': 'Toelettatrice',
        // Contact
        'contact.title': 'Contattaci',
        'contact.phone_label': 'Telefono',
        'contact.email_label': 'Email',
        // Footer
        'footer.copyright': "\xa9 2025 Petwell. Tutti i diritti riservati.",
        // Alts
        'alt.hero_image': 'Gatto e cane',
        'alt.cat_on_sofa': 'Gatto al computer',
        'alt.dog_head': 'Cucciolo sdraiato',
        'alt.cat_and_mouse': 'Gatto dietro un mouse del computer',
        'alt.cat_headphone': 'Gatto con megafono e occhiali'
    },
    el: {
        // Meta
        'meta.title': "Petwell \u2013 \u0397 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03BB\u03CD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03C5\u03B6\u03C9\u03AF\u03B1\u03C2 \u03B6\u03CE\u03C9\u03BD",
        'meta.description': "Petwell: online \u03B7\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF, \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2, \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B5\u03C2 \u03C5\u03C0\u03B5\u03BD\u03B8\u03C5\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2, \u03C3\u03C4\u03B1\u03C4\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC, \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2 \u03BA\u03B1\u03B9 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03B2\u03B9\u03C4\u03C1\u03AF\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03C5\u03B6\u03C9\u03AF\u03B1\u03C2 \u03B6\u03CE\u03C9\u03BD.",
        // Hero
        'hero.title': "\u0397 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03BB\u03CD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03C5\u03B6\u03C9\u03AF\u03B1\u03C2 \u03B6\u03CE\u03C9\u03BD",
        'hero.cta': "\u0396\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B5\u03C0\u03AF\u03B4\u03B5\u03B9\u03BE\u03B7",
        // Intro
        'intro.title': "\u039C\u03B9\u03B1 \u03B1\u03C0\u03BB\u03AE \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03C3\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u03C0\u03BB\u03B1\u03C4\u03C6\u03CC\u03C1\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03B1 \u03BA\u03B5\u03BD\u03C4\u03C1\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B1",
        'intro.text': "\u039F\u03B9 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03C5\u03B6\u03C9\u03AF\u03B1\u03C2 \u03B6\u03CE\u03C9\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03BC\u03B9\u03BA\u03C1\u03AE \u03BF\u03C1\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1, \u03C7\u03AC\u03BD\u03BF\u03C5\u03BD \u03C7\u03C1\u03CC\u03BD\u03BF \u03BC\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03BF\u03B9\u03BA\u03B7\u03C4\u03B9\u03BA\u03AE \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC \u03BA\u03B1\u03B9 \u03B4\u03C5\u03C3\u03BA\u03BF\u03BB\u03B5\u03CD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BD \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2. \u03A4\u03BF Petwell \u03B1\u03C0\u03BB\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF \u03BA\u03B1\u03B9 \u03BA\u03B5\u03BD\u03C4\u03C1\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF \u03C4\u03B1 \u03C0\u03AC\u03BD\u03C4\u03B1.",
        // Features
        'features.title': "\u039B\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B5\u03C2",
        'features.agenda': "Online \u03B7\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF",
        'features.vitrine': "\u03A8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03B2\u03B9\u03C4\u03C1\u03AF\u03BD\u03B1",
        'features.secure_payment': "\u0391\u03C3\u03C6\u03B1\u03BB\u03AE\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
        'features.stats': "\u03A3\u03C4\u03B1\u03C4\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC \u03BA\u03B1\u03B9 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AD\u03C2",
        'features.booking': "Online \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2",
        'features.reminders': "\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B5\u03C2 \u03C5\u03C0\u03B5\u03BD\u03B8\u03C5\u03BC\u03AF\u03C3\u03B5\u03B9",
        // Prepay
        'prepay.title': "\u03A0\u03C1\u03BF\u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03B5\u03B9\u03C9\u03B8\u03BF\u03CD\u03BD \u03C4\u03B1 no\u2011show",
        'prepay.text': "\u03A4\u03BF Petwell \u03B5\u03BD\u03C3\u03C9\u03BC\u03B1\u03C4\u03CE\u03BD\u03B5\u03B9 \u03C3\u03CD\u03C3\u03C4\u03B7\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03BC\u03B7\u03BC\u03B1\u03C4\u03B9\u03BA\u03CE\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD \u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C1\u03B1\u03BD\u03C4\u03B5\u03B2\u03BF\u03CD \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03B9\u03BF \u03B1\u03C3\u03C6\u03B1\u03BB\u03AE: \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B7\u03C2 \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1\u03C2 \u03C3\u03C4\u03B9\u03B3\u03BC\u03AE\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B7 \u03B7\u03C1\u03B5\u03BC\u03AF\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2.",
        // Mobile
        'mobile.title': "\u0388\u03BD\u03B1 mobile \u03B5\u03C1\u03B3\u03B1\u03BB\u03B5\u03AF\u03BF \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03C3\u03B5 \u03BA\u03AF\u03BD\u03B7\u03C3\u03B7",
        'mobile.text': "\u039C\u03B5 \u03C4\u03BF Petwell \u03BF\u03B9 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B4\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C4\u03BF \u03B7\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF, \u03C4\u03B9\u03C2 \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03C4\u03BF\u03C5\u03C2 \u03B2\u03B9\u03C4\u03C1\u03AF\u03BD\u03B1 \u03B1\u03C0\u03B5\u03C5\u03B8\u03B5\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF smartphone. \u039C\u03B9\u03B1 \u03B1\u03C0\u03BB\u03AE \u03BA\u03B1\u03B9 \u03B5\u03C5\u03AD\u03BB\u03B9\u03BA\u03C4\u03B7 \u03BB\u03CD\u03C3\u03B7, \u03B9\u03B4\u03B1\u03BD\u03B9\u03BA\u03AE \u03B3\u03B9\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9\u03C2.",
        // Reviews
        'reviews.title': "\u03A4\u03B9 \u03BB\u03AD\u03BD\u03B5 \u03BF\u03B9 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03BC\u03B1\u03C2",
        'reviews.card1.text': "\u03A4\u03BF PetWell \u03BC\u03BF\u03CD \u03B5\u03C0\u03AD\u03C4\u03C1\u03B5\u03C8\u03B5 \u03BD\u03B1 \u03BA\u03B5\u03C1\u03B4\u03AF\u03C3\u03C9 30% \u03C7\u03C1\u03CC\u03BD\u03BF \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC\u03C2 \u03BC\u03BF\u03C5.",
        'reviews.card1.role': "\u0395\u03BA\u03C0\u03B1\u03B9\u03B4\u03B5\u03CD\u03C4\u03C1\u03B9\u03B1",
        'reviews.card2.text': "\u0395\u03C0\u03B9\u03C4\u03AD\u03BB\u03BF\u03C5\u03C2 \u03BC\u03B9\u03B1 online \u03B2\u03B9\u03C4\u03C1\u03AF\u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03BF \u03B5\u03C0\u03AC\u03B3\u03B3\u03B5\u03BB\u03BC\u03AC \u03BC\u03BF\u03C5.",
        'reviews.card2.role': "\u03A3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03C6\u03BF\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2",
        'reviews.card3.text': "\u03A7\u03AC\u03C1\u03B7 \u03C3\u03C4\u03B9\u03C2 online \u03C0\u03C1\u03BF\u03BA\u03B1\u03C4\u03B1\u03B2\u03BF\u03BB\u03AD\u03C2 \u03BC\u03B5 \u03C4\u03BF PetWell, \u03BC\u03B5\u03AF\u03C9\u03C3\u03B1 \u03C3\u03C4\u03BF \u03BC\u03B9\u03C3\u03CC \u03C4\u03B1 \u03C7\u03B1\u03BC\u03AD\u03BD\u03B1 \u03C1\u03B1\u03BD\u03C4\u03B5\u03B2\u03BF\u03CD.",
        'reviews.card3.role': 'Groomer',
        // Contact
        'contact.title': "\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2",
        'contact.phone_label': "\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF",
        'contact.email_label': 'Email',
        // Footer
        'footer.copyright': "\xa9 2025 Petwell. \u038C\u03BB\u03B1 \u03C4\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1 \u03B4\u03B9\u03B1\u03C4\u03B7\u03C1\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9.",
        // Alts
        'alt.hero_image': 'Chat et chien',
        'alt.cat_on_sofa': "Chat sur un ordinateur portable",
        'alt.dog_head': "Chiot couch\xe9",
        'alt.cat_and_mouse': "Chat derri\xe8re une souris d\u2019ordinateur",
        'alt.cat_headphone': "Chat avec m\xe9gaphone et lunettes"
    }
};
const DEFAULT_LANG = 'fr';
const SUPPORTED_LANGS = Object.keys(translations);
const STORAGE_KEY = 'petwell_lang';
function getInitialLang() {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const fromUrl = urlParams.get('lang');
        if (fromUrl && SUPPORTED_LANGS.includes(fromUrl)) return fromUrl;
    } catch (e) {
    // ignore
    }
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    } catch (e) {
    // ignore
    }
    if (typeof navigator !== 'undefined' && navigator.language) {
        const navLang = navigator.language.toLowerCase();
        if (navLang.startsWith('it')) return 'it';
        if (navLang.startsWith('fr')) return 'fr';
        if (navLang.startsWith('el')) return 'el';
    }
    return DEFAULT_LANG;
}
function updateLangSwitcherUI(lang) {
    const select = document.getElementById('lang-select');
    if (select && select.value !== lang) select.value = lang;
}
function applyTranslations(lang) {
    const dict = translations[lang] || translations[DEFAULT_LANG];
    // Attribut lang sur le <html>
    if (document.documentElement) document.documentElement.lang = lang;
    // Title
    if (dict['meta.title']) document.title = dict['meta.title'];
    // Meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && dict['meta.description']) metaDesc.setAttribute('content', dict['meta.description']);
    // Textes
    document.querySelectorAll('[data-i18n-key]').forEach((el)=>{
        const key = el.getAttribute('data-i18n-key');
        const value = dict[key];
        if (value) el.textContent = value;
    });
    // Alts
    document.querySelectorAll('[data-i18n-alt]').forEach((el)=>{
        const key = el.getAttribute('data-i18n-alt');
        const value = dict[key];
        if (value) el.setAttribute('alt', value);
    });
    updateLangSwitcherUI(lang);
    try {
        window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
    // ignore
    }
}
function setupLangSwitcher() {
    const select = document.getElementById('lang-select');
    if (!select) return;
    select.addEventListener('change', (event)=>{
        const lang = event.target.value;
        if (lang && SUPPORTED_LANGS.includes(lang)) applyTranslations(lang);
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    const initialLang = getInitialLang();
    setupLangSwitcher();
    applyTranslations(initialLang);
});

//# sourceMappingURL=index.fc73cb03.js.map
